<app-navbar-container breadcrumb="Admin">
  <app-navbar-item-large [link]="'/' + Routes.AdminUsers" title="Benutzer">
    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2"/>
    </svg>
  </app-navbar-item-large>
</app-navbar-container>
